import { useState } from "react";

function InvoiceData({ parsedData }) {
  const [copiedField, setCopiedField] = useState(null);

  const handleCopy = (key, value) => {
    navigator.clipboard.writeText(value).then(() => {
      setCopiedField(key);
      setTimeout(() => setCopiedField(null), 1500);
    });
  };

  if (!parsedData) return null; // No data, don't render

  return (
    <div className="invoice-data">
      <h3>Extracted Invoice Data</h3>
      <table>
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
            <th>Copy</th>
          </tr>
        </thead>
        <tbody>
          {[
            { key: "invoiceNumber", label: "Invoice Number" },
            { key: "invoiceDate", label: "Invoice Date" },
            { key: "workOrder", label: "Work Order" },
            { key: "dueDate", label: "Due Date" },
            { key: "toDate", label: "Service To Date" },
            { key: "fromDate", label: "Service From Date" },
            { key: "accountNumber", label: "Account Number" },
            { key: "vendor", label: "Vendor Name" },
            { key: "billTo", label: "Billed To" },
            { key: "amountDue", label: "Amount Due" },
            { key: "poNumber", label: "Purchase Order (PO) Number" },
            { key: "salesTax", label: "Sales Tax" },
            { key: "invoiceTotal", label: "Total Invoice Amount" },
            { key: "propertyName", label: "Property Name" },
          ].map(({ key, label }) => (
            <tr key={key}>
              <td>{label}</td>
              <td style={{ whiteSpace: "pre-line" }}>
                {parsedData[key] || "Not Found"}
              </td>
              <td>
                {parsedData[key] && parsedData[key] !== "Not Found" && (
                  <button onClick={() => handleCopy(key, parsedData[key])}>
                    {copiedField === key ? "✅ Copied!" : "📋 Copy"}
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default InvoiceData;
